import { UntypedFormGroup } from "@angular/forms";
import moment from "moment";

/**
 * Converts a formGroup with a date and a time control to a single dateTime value.
 *
 * @param form - UntypedFormGroup with a date and time control.
 * @param format - Property of the value you want to convert to.
 */
export const convertToDateTime = (form: UntypedFormGroup, format = "YYYY-MM-DD HH:mm"): string => {
	const { date, time } = form.value;

	if (!date || !time) {
		return "";
	}

	const parsedDate = moment(`${date} ${time}`, format);

	if (!parsedDate.isValid()) {
		return "";
	}

	return parsedDate.format();
};
